import * as types from './action-types'
import { fromJS } from 'immutable'

const InitialState = fromJS({
  fetching: false,
  data: null,
  requestId: null
})

export default (state = InitialState, action) => {
  switch (action.type) {
    case types.REQUEST_ARTIST_CASE_STUDY:
      return state
        .set('requestId', action.payload)
        .set('fetching', true)
        .set('data', null)

    case types.RECEIVE_ARTIST_CASE_STUDY:
      return state
        .set('data', fromJS(action.payload.data.message))
        .set('fetching', false)

    case types.ERROR_ARTIST_CASE_STUDY:
      return state.set('fetching', false)

    default:
        return state
  }
}



// WEBPACK FOOTER //
// ./src/components/artist-case-studies-container/reducer.js